import firebase from '@firebase/app'
import '@firebase/auth'
import '@firebase/firestore'
import '@firebase/storage'

var config = {
  apiKey: 'AIzaSyDD_fY-rlXV7AaG4kz0VvemKt8Wx-Fap40',
  authDomain: 'pft-report.firebaseapp.com',
  databaseURL: 'https://pft-report.firebaseio.com',
  projectId: 'pft-report',
  storageBucket: 'pft-report.appspot.com',
  messagingSenderId: '998579583430'
}

// var config = {
//   apiKey: "AIzaSyBc66FbvoAyylhY6pX463Y1X4GH4NqtfRE",
//   authDomain: "pft-admin.firebaseapp.com",
//   databaseURL: "https://pft-admin.firebaseio.com",
//   projectId: "pft-admin",
//   storageBucket: "pft-admin.appspot.com",
//   messagingSenderId: "264112904140"  
// }

firebase.initializeApp(config)

export default firebase